module.exports = __webpack_public_path__ + "media/images/side_filter-fd99a194.png";